import { useNavigate } from "react-router-dom";
import { clearActiveAuth } from "../../utils/authSession";
function LogOut() {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearActiveAuth();

    navigate("/");
  };

  return (
    <button
      onClick={handleLogout}
      className="text-white bg-red-600 cursor-pointer font-bold py-1 px-3 rounded-lg transition"
      >
        Log Out
    </button>
  );
}

export default LogOut;
